// Mock API service for Spending Controls integration

export const mockFetchCardLimits = async ({ userID, cardNumber }) => {
  // Simulate Velera/SymXchange response structure
  return {
    deliveryTargets: [
      { target: "123-456-7890", type: "sms", isPrimary: true },
      { target: "test@domain.com", type: "email", isPrimary: false }
    ],
    controls: [
      {
        displayName: "Merchant Types",
        id: "C04",
        enabled: true,
        category: "merchantTypes",
        options: [
          { displayName: "Personal Care", description: "Drug stores, pharmacies, health professional services, medical services and labs, ambulance services, legal services, and attorneys.", id: "C04T05" },
          { displayName: "Restaurant", description: "Diners, fast-food restaurants, and caterers.", id: "C04T06" },
          { displayName: "Travel", description: "Airlines, cars and automotive rentals, hotels, motels, inns, resorts, toll and bridge fees, taxicabs and limousines, timeshares, parking lots, and garages.", id: "C04T07" }
        ],
        valueType: "arrayOfStrings",
        value: ["C04T06"]
      },
      {
        displayName: "Spend Limits - Per Card",
        id: "C014",
        enabled: true,
        category: "spendingLimits",
        valueType: "integer",
        value: 50
      }
    ],
    alerts: [
      {
        displayName: "Merchant Types",
        id: "A04",
        enabled: true,
        category: "alerts",
        options: [
          { displayName: "Personal Care", description: "Drug stores, pharmacies, health professional services, medical services and labs, ambulance services, legal services, and attorneys.", id: "A04T05" },
          { displayName: "Restaurant", description: "Diners, fast-food restaurants, and caterers.", id: "A04T06" }
        ],
        valueType: "arrayOfStrings",
        value: ["A04T06"]
      }
    ]
  };
};

export const mockUpdateCardLimits = async (payload) => {
  // Simulate a successful update
  return { status: "success" };
};

// Utility to prefix userID with REGO-
export const getRegoUserId = (userId) => `REGO-${userId}`;

// Utility to map UI state to API request format
export const mapUiStateToApi = ({ userId, cardNumber, controls, alerts, deliveryTargets }) => {
  // Only send changed controls/alerts (simulate all for now)
  return {
    userID: getRegoUserId(userId),
    cardNumber,
    deliveryTargets,
    controls: controls.map(({ id, enabled, value }) => ({ id, enabled, value })),
    alerts: alerts.map(({ id, enabled, value }) => ({ id, enabled, value }))
  };
};

// Utility to map API response to UI state
export const mapApiToUiState = (apiResponse) => {
  return {
    deliveryTargets: apiResponse.deliveryTargets,
    controls: apiResponse.controls,
    alerts: apiResponse.alerts
  };
};
